import React from 'react';
import moment from "moment";
import { createContext, useContext, useEffect, useState } from "react";
import { useFilterContext } from "../../../hooks/FilterContext";
import { useLazySearchFeeGroupsQuery } from "../../../services/headofficeadmin";

const SearchFeesContext = createContext();

export const useSearchFees = () => useContext(SearchFeesContext);


const SearchFeesProvider = ({ children, searchType}) => {

    //const [sort, setSort] = useState("feeDate+ASC");
    const [sort, setSort] = useState("feeDate+DESC");
    const [pageLimit, setPageLimit] = useState(25);
    const [cacheKey, setCacheKey] = useState(new Date().valueOf());
    const [isLoadingState, setIsLoadingState] = React.useState(false);

    const { filter, isReady } = useFilterContext();
    const [searchTrigger, { data, isLoading, isFetching, isError, error, isUninitialized }] = useLazySearchFeeGroupsQuery();

    const { pagination, results, newRecordsSinceCache } = data || { pagination: { page: 1, pageSize: pageLimit, totalCount: 0, totalPages: 1 }, results: [], newRecordsSinceCache: 0 };
    const { page, pageSize, totalCount, totalPages } = pagination;
    const hasMore = totalCount > 0 && page < totalPages;
    const isNextPageLoading = isFetching === true || isLoading === true || isLoadingState === true;
    
    //const [limit, setLimit] = useState(25);
    
    ////const { hasMore, results, pagination } = data || { results: [], pagination: {page: 0}, hasMore: true };
    //const { hasMore, results, pagination } = data || { results: [], pagination: {page: 1}, hasMore: true };
    ////const { page } = pagination || { page: 0 };
    //const { page } = pagination || { page: 1 };
    //const isNextPageLoading = isFetching === true || isLoading === true; //added
    //const [isClearing, setIsClearing] = useState(false);

    //console.log('search filter for fees or cash - type ',searchType, 'filter ',filter);

    const clear = () => {
       // safety check to make sure we don't reload when already loading!
        if (isNextPageLoading || !isReady) {
            return;
        }
        
        const newCacheKey = new Date().valueOf();
        setIsLoadingState(_ => true);
        //setIsClearing(true);
        searchTrigger({
            cacheKey: newCacheKey,
            searchType: searchType,
            filter:{
                ...filter,
                adviserIds: filter.advisers?.map(x => x.value) ?? [],
                introducerIds: filter.introducers?.map(x => x.value) ?? [],
                masterAccountIds: filter.masterAccounts?.map(x => x.value) ?? [],
                providerIds: filter.providers?.map(x => x.value) ?? [],
                startDate: filter?.startDate ?? moment().startOf('month').format('YYYY/MM/DD'),
                endDate: filter?.endDate ?? null,
                limit: pageLimit,
                page: 1,
                sort
            }
        })
        .unwrap()
        .then(
            _ => {
                setCacheKey(_prev => newCacheKey);   
            }
        )
        .finally(setIsLoadingState(_prev => false));
        //.finally(() => { 
            //setCacheKey(_ => newCacheKey); 
            //setIsClearing(false); 
        //});
    };
    
    const isItemLoaded = (index) => index < results.length || results[index];
    //const isRowLoaded = (index) => !hasMore || index < results.length;
    const isRowLoaded = (index) => results[index] || index < results.length;

    const loadMoreItems = () => {
         // safety check to make sure we don't reload when already loading!
         if (isNextPageLoading) {
            return;
        }
        setIsLoadingState(_ => true);
        searchTrigger({
            cacheKey,
            searchType: searchType,
            filter:{...filter,
            adviserIds: filter.advisers?.map(x => x.value) ?? [],
            introducerIds: filter.introducers?.map(x => x.value) ?? [],
            masterAccountIds: filter.masterAccounts?.map(x => x.value) ?? [],
            providerIds: filter.providers?.map(x => x.value) ?? [],
            startDate: filter?.startDate ?? moment().startOf('month').format('YYYY/MM/DD'),
            endDate: filter?.endDate ?? null,
            limit: pageLimit,
            page: page + 1,
            sort}

        })
        .unwrap()
        .finally(setIsLoadingState(_prev => false));
    };

    const retrySearchFees = (e) => {
        if (isUninitialized || !isReady || isNextPageLoading ) return; //added
        if (e && typeof (e) === "function") {
            e.preventDefault();
        }

        clear();
    };

    const updateSort = (property) => {
        const [oldProperty, direction] = sort.split("+");

        if (oldProperty === property) {
            return setSort(`${property}+${direction === "ASC" ? "DESC" : "ASC"}`)
        }

        setSort(`${property}+DESC`);
    };
   
    useEffect(clear, [filter, sort, isReady]);

    return <SearchFeesContext.Provider value={{
        results: results || [],
        //totalCount: results.length > 0 && hasMore ? results.length + limit : results.length,
        //isClearing,
        error,
        isError,
        sort,
        clear,
        hasMore,
        isLoading,
        isFetching,
        isNextPageLoading,
        isNewRecords: newRecordsSinceCache > 0,
        isItemLoaded,
        isRowLoaded,
        limit: pageLimit,
        loadMoreItems: isNextPageLoading ? () => {} : loadMoreItems,
        retrySearchFees,
        page,
        pagination,
        updateSort,
        totalCount,
        totalPages
    }}>
        {children}
    </SearchFeesContext.Provider>
};
//};
export default SearchFeesProvider;